<div class="p-6">
    <cac-table [options]="table" #tableRef>
        <div slot="header-start" class="flex gap-2 items-center">
            <cac-table-column-selector
                [tableRef]="tableRef"
                [storageKey]="'order-items-report-table'"
                [label]="'Visible Columns'"
                [placeholder]="'Choose columns to display'">
            </cac-table-column-selector>
        </div>

        <div slot="footer" class="flex flex-col justify-between items-start p-2 space-y-2">
            <div class="text-sm font-medium">
                <span class="text-gray-600">Total Quantity: </span>
                <span class="text-gray-900">{{ totalQuantity() }}</span>
            </div>
            <div class="text-sm font-medium">
                <span class="text-gray-600">Total Price: </span>
                <span class="text-gray-900">{{ totalPrice() | kwdCurrency }}</span>
            </div>
        </div>
    </cac-table>
</div>